<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="editGreyFabricOptions.visible"
      :greyFabricCode="editGreyFabricOptions.greyFabricCode"
      :pageType="editGreyFabricOptions.pageType"
      :title="editGreyFabricOptions.title"
      @reload="reload"
    ></Detail>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import Detail from '../../detail'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Detail },
  data() {
    return {
      usePage: true,
      editGreyFabricOptions: {
        visible: false,
        greyFabricCode: '',
        pageType: '',
        title: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterGreyFabricListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, greyFabricCode }) {
      const titleMap = {
        add: this.$l('dialog_title_add_greyfabric_info') || '添加面料坯布信息',
        edit:
          this.$l('dialog_title_edit_greyfabric_info') || '编辑面料坯布信息',
        detail:
          this.$l('dialog_title_view_greyfabric_info') || '查看面料坯布信息',
      }
      this.editGreyFabricOptions.pageType = pageType
      this.editGreyFabricOptions.visible = true
      this.editGreyFabricOptions.greyFabricCode = greyFabricCode
      this.editGreyFabricOptions.title = titleMap[pageType]
    },
  },
}
</script>
